import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "filter-box" }
const _hoisted_16 = { class: "filter-box" }
const _hoisted_17 = { class: "filter-box" }
const _hoisted_18 = { class: "split-table-layout" }
const _hoisted_19 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_20 = { class: "tab-title_left fl" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_OutsourceFee = _resolveComponent("OutsourceFee")!
  const _component_MarketFee = _resolveComponent("MarketFee")!
  const _component_LogisticTable = _resolveComponent("LogisticTable")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_QutsourceFeeForm = _resolveComponent("QutsourceFeeForm")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "公司名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompanyName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.customerCompanyName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "业务品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.brand,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.brand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.name) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.model) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "序列号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.serial,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.serial) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "订单号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerOrderNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.customerOrderNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleSalesManFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_ctx.salesManOption.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.salesManOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          value: -1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode("暂无数据", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "工程师", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.engineerId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.engineerId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleEngineerFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_ctx.engineerOption.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.engineerOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          value: -1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                            _createTextVNode("暂无数据", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "紧急程度", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.urgentId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.urgentId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, {
                  default: _withCtx(() => [
                    (_ctx.urgentOption.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.urgentOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          value: -1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode("暂无数据", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "外包商", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.outsourceCompanyName,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.outsourceCompanyName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  clearable: ""
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.listQuery.outsourceFeeStatus,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listQuery.outsourceFeeStatus) = $event)),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode("未申请", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "4" }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode("可申请", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("未付款", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "3" }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                        _createTextVNode("未开票", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "9" }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode("全部", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCommand('outSourceCompany')))
          }, {
            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
              _createTextVNode(" 新建外包商 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_COMPANY_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[45] || (_cache[45] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[46] || (_cache[46] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[47] || (_cache[47] = _createElementVNode("span", { class: "ml-10 filter-mark" }, "此列表只显示需要申请外包费和维修完成的业务，外包费全部审批完成之后才显示维修完成", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            showSelection: true,
            isShowPagination: false,
            handleDefaultWidth: 160,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            style: {"height":"100%","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            "operation-action": _withCtx((scope) => [
              _createVNode(_component_CommandRender, {
                scopeRow: scope.row,
                codeList: _ctx.btnList,
                permissionName: _ctx.permissionName,
                onCommandChange: _ctx.handleCommand
              }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("ul", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_21))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_ContactList, {
                key: 0,
                ref: "ContactList",
                id: _ctx.activeId
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_OutsourceFee, {
                key: 1,
                ref: "OutsourceFee",
                id: _ctx.activeId,
                businessDetail: _ctx.activeRow
              }, null, 8, ["id", "businessDetail"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 4)
            ? (_openBlock(), _createBlock(_component_MarketFee, {
                key: 2,
                ref: "MarketFee",
                id: _ctx.activeId,
                marketFeeCanCommand: false
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 5)
            ? (_openBlock(), _createBlock(_component_LogisticTable, {
                key: 3,
                sendFlag: 0,
                TableName: "TABLE_DELIVERY_INFO",
                permissionName: "LOGISTIC_INFO",
                ref: "LogisticTable",
                sourceId: _ctx.activeId,
                sourceType: 2,
                canCommand: false
              }, null, 8, ["sourceId"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 3)
            ? (_openBlock(), _createBlock(_component_TraceInfo, {
                key: 4,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "business"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.outsourceCompanyVisible && !_ctx.outsourceFeeFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'business',
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[19] || (_cache[19] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "commandState"]))
      : _createCommentVNode("", true),
    (_ctx.outsourceCompanyVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 1,
          id: 0,
          initFormData: _ctx.initFormDataOutsourceCompany,
          fromFieldData: _ctx.fromFieldDataOutsourceCompany,
          dialogFormVisible: _ctx.outsourceCompanyVisible,
          handleResolveTempData: _ctx.handleResolveTempDataOutsourceCompany,
          api: 'outsourceCompany',
          "onUpdate:visibel": _cache[21] || (_cache[21] = () => _ctx.outsourceCompanyVisible = false),
          onSubmit: _ctx.handleOutsourceCompanySubmit
        }, null, 8, ["initFormData", "fromFieldData", "dialogFormVisible", "handleResolveTempData", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.outsourceFeeFormVisible)
      ? (_openBlock(), _createBlock(_component_QutsourceFeeForm, {
          key: 2,
          id: 0,
          businessDetail: _ctx.activeRow,
          dialogFormVisible: _ctx.outsourceFeeFormVisible,
          api: 'outsourceFee',
          "onUpdate:visibel": _cache[22] || (_cache[22] = ($event: any) => (_ctx.outsourceFeeFormVisible = false)),
          onSubmit: _ctx.getList
        }, null, 8, ["businessDetail", "dialogFormVisible", "onSubmit"]))
      : _createCommentVNode("", true),
    _cache[48] || (_cache[48] = _createTextVNode()),
    (!_ctx.dialogFormVisible && !_ctx.outsourceCompanyVisible && !_ctx.outsourceFeeFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}